import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Panel } from 'primereact/panel';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Button } from 'primereact/button';
import { intlShape } from '../../../../../components/prop-types';


const i18n = defineMessages({
  header: {
    id: 'file_import.header.active',
    defaultMessage: 'Activate Import File',
  },
});


const ImportConfirmModal = (props) => {
  const {
    reject,
    confirm,
    modalOpen,
    intl: { formatMessage },
  } = props;

  const headerMessage = formatMessage(i18n.header);


  const dialogFooter = (
    <Fragment>
      <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
        {text => (
          <Button
            className="p-button-secondary"
            label={text}
            onClick={reject}
          />
        )}
      </FormattedMessage>
      &nbsp;
      <FormattedMessage id="actions.activate" defaultMessage="Activate">
        {text => (
          <Button label={text} type="button" onClick={confirm} />
        )}
      </FormattedMessage>
    </Fragment>
  );
  return (
    <Dialog
      header={headerMessage}
      footer={dialogFooter}
      visible={modalOpen}
      onHide={reject}
      modal
    >
      <Panel>
        <div className="p-grid p-fluid">
          <div className="p-col">
            <FormattedMessage
              id="file_import.mes.confirm_active_status"
              defaultMessage="Clicking OK will import respondents and create assessments for SuperLink"
            />
          </div>
        </div>
      </Panel>
    </Dialog>
  );
};

ImportConfirmModal.propTypes = {
  reject: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
};

export default withRouter(injectIntl(ImportConfirmModal));
